import React, { Component } from 'react';
import LanguageIcon from 'material-ui/svg-icons/action/language';
import Cookies from 'universal-cookie';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Checkbox from 'material-ui/Checkbox';
import ArrowBackIcon from 'material-ui/svg-icons/navigation/arrow-back';
import EventIcon from 'material-ui/svg-icons/action/event';
import CircularProgress from 'material-ui/CircularProgress';
import _ from 'lodash';
import moment from 'moment';
import async from "async";

import * as DataAPI from "../common/DataAPI.js";
import Dialogs from "../common/Dialogs.js";
import constants from "../common/constants.js";
import * as SocketIO from "../common/SocketIO";
import FileUploadIcon from "../adminPanel/panel/displays/PhotosDialog";
import * as history from "../common/history";

const { default: PQueue } = require('p-queue');
const pQueue = new PQueue({ concurrency: 1 });

const cookies = new Cookies();

const styles = {
  name: {
    textField: {
      // width: 110,
    },
  },
  radioButtonGroup: {
    display: 'inline-flex',
  },
  radioButton: {
    width: 110,
  },
};

const COUNTRY_CODES = ['852', '86', '853'];
const EMPTY_INPUT = {
  queueId: '',
  noOfChild: null,
  phoneNumber: '',
  email: '',
  orderNo: '',
};
const MESSAGES = constants.localeMessage;
const RESERVED_OPTIONS = [
  {
    text: MESSAGES.NO_CHANGE,
    value: 'NO_CHANGE',
  },
  {
    text: MESSAGES.CHANGE_TIME_NO_OF_PPL,
    value: 'CHANGE',
  },
  {
    text: MESSAGES.CANCEL,
    value: 'CANCEL',
  },
]
const DATE_FORMAT = 'YYYYMMDD';

class Ticket extends Component {
  constructor(props) {
    super();

    const query = _.split(_.replace(_.get(props, 'location.search'), '?', ''), '&')

    let lang = 'en', bookedTicketUuid;
    _.forEach(query, item => {
      if (_.startsWith(item, 'lang')) {
        lang = _.last(_.split(item, '='));
      }

      if (_.startsWith(item, 'ticket')) {
        bookedTicketUuid = _.last(_.split(item, '='));
      }
    });

    this.state = {
      windowWidth: window.innerWidth,
      lang,
      queues: [],
      queueSelected: '',
      dates: [],
      services: [],
      bookedTicket: null,
      bookedTicketUuid,
      selectedInNonReservedServices: [],
      timeSlots: [],
      input: EMPTY_INPUT,
      widthFlag: '',
      isProcessing: false,
      ticketId: cookies.get('ticketId'),
      ticket: null,
      lastCalledTicketNumber: null,
      isFlashing: false,
      flashingTimer: null,
      timeSlotsWithServices: [],
      step: 0, //0: Waiting queue  1: Select item, 2: Select time slot, 3: Confirm selection / Input room no., 4: Booking Info
      isQueueIdle: true,
      isNavigateToTimeSlots: false,
      selectedInTimeSlot: [
        // {
        //   serviceId:'1234',
        //   timeSlotValue:'123',
        //   noOfPeople:1,
        // }
      ],
      errorsInBookingInfo: [
        //   {
        //     service:'',
        //     errorMsg:'',
        //   }
      ],
      bookings: [],
      isRoomNoInputState: false,
      selectedInReservedOptions: [
        // {
        //   booking:{},
        //   selected:'',
        // }
      ],
      nonReservedServices: [],
      lastCalledTickets: [],
      shouldShowTicketPassed: false,
    };

    this.updateInputState = this.updateInputState.bind(this);
    this.createTicket = this.createTicket.bind(this);
    this.updateWidthFlag = this.updateWidthFlag.bind(this);
    this.isSubmitButtonDisabled = this.isSubmitButtonDisabled.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.backStep = this.backStep.bind(this);
    this.backToFirstStep = this.backToFirstStep.bind(this);
    this.navigateToBooking = this.navigateToBooking.bind(this);
    this.navigateToSelectService = this.navigateToSelectService.bind(this);
    this.selectReservedOption = this.selectReservedOption.bind(this);
    this.navigateToTimeSlots = this.navigateToTimeSlots.bind(this);
    this.updateSelectedInTimeSlot = this.updateSelectedInTimeSlot.bind(this);
    this.formatSelectTimeSlotTime = this.formatSelectTimeSlotTime.bind(this);
    this.confirmBooking = this.confirmBooking.bind(this);
    this.confirmRoomNo = this.confirmRoomNo.bind(this);
    this.navigateToInputRoomNo = this.navigateToInputRoomNo.bind(this);
    this.navigateToReservation = this.navigateToReservation.bind(this);
    this.navigateToBookingInfo = this.navigateToBookingInfo.bind(this);
    this.isSelectedInTimeSlotValid = this.isSelectedInTimeSlotValid.bind(this);
    this.confirmTimeSlot = this.confirmTimeSlot.bind(this);
    this.selectNonReservedService = this.selectNonReservedService.bind(this);
    this.getSelectedInTimeSlot = this.getSelectedInTimeSlot.bind(this);
    this.backInTimeSlotConfirmation = this.backInTimeSlotConfirmation.bind(this);
    this.backFromRoomNoInputState = this.backFromRoomNoInputState.bind(this);
    this.cancelTicket = this.cancelTicket.bind(this);
  }

  async componentWillMount() {
    this.updateWidthFlag();
    this.fetchQueues();

    if (this.state.ticketId) {
      this.getTicket(this.state.ticketId, (err, ticket) => {
        if (err) return this.dialogs.error(MESSAGES.NETWORK_PROBLEM[this.state.lang], this.state.lang);

        if (!ticket) {
          return cookies.remove('ticketId');
        }

        this.setState({
          ticket,
        }, () => {
          this.refreshLastCalledTicket(ticket.queue);
        });
      });
    } else {
      this.fetchLastCalledTickets();
    }
  }

  componentDidMount() {
    const self = this;

    window.addEventListener("resize", this.updateWidthFlag.bind(this));

    SocketIO.on('refreshLastCalledTicket', ({ lastCalledTicket }) => {
      if (lastCalledTicket.queue.code !== _.get(this.state.ticket, 'queue.code')) return;

      const lastCalledTicketNumber = lastCalledTicket.queue.code + _.padStart(lastCalledTicket.number, constants.numberOfTicketDigit, '0');

      let ticket = _.cloneDeep(this.state.ticket);
      if (ticket._id === lastCalledTicket._id) {
        _.set(ticket, 'counter', lastCalledTicket.counter);
      }

      const shouldShowTicketPassed = lastCalledTicket.number > ticket.number;

      this.setState({
        lastCalledTicketNumber,
        ticket,
        shouldShowTicketPassed,
      });
      this.flashLastCalledTicket();
    });

    SocketIO.on('requeueTicket', ({ requeuedTicket }) => {
      if (requeuedTicket._id === _.get(this.state.ticket, '_id')) {
        let ticket = _.cloneDeep(this.state.ticket);

        _.set(ticket, 'counter', requeuedTicket.counter);

        this.setState({
          ticket,
        });
      }
    });

    setInterval(() => {
      if (this.state.ticket && !_.get(this.state.ticket, 'counter')) {
        this.refreshLastCalledTicket(this.state.ticket.queue);
      }
    }, 20000);

    pQueue.on('add', () => {
      self.setState({
        isQueueIdle: false,
      });
    });

    pQueue.on('idle', () => {
      // console.log(`Queue is idle.  Size: ${pQueue.size}  Pending: ${pQueue.pending}`);
      self.setState({
        isQueueIdle: true,
      });
    });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWidthFlag.bind(this));
  }

  fetchServices() {
    return new Promise((resolve, reject) => {
      DataAPI.get(`/api/public/services`, {}, (err, services) => {
        if (err) return reject(err);

        resolve(services);
      });
    });
  }

  fetchLastCalledTickets() {
    DataAPI.get('/api/public/lastCalledTickets', {}, (err, lastCalledTickets) => {
      if (err) {
        this.dialogs.error(MESSAGES.SYSTEM_BUSY[this.state.lang], this.state.lang);
        return console.error('get lastCalledTickets error:', JSON.stringify(err));
      }

      lastCalledTickets = _.map(lastCalledTickets, ticket => {
        return _.set(ticket, 'numberToShow', _.padStart(ticket.number, constants.numberOfTicketDigit, '0'))
      });

      this.setState({
        lastCalledTickets,
      });
    });
  }

  navigateToBookingInfo() {
    this.fetchBookings(() => {
      this.setState({
        step: 4
      });
    });
  }

  navigateToReservation() {
    this.fetchBookings(() => {
      if (_.size(this.state.bookings)) {
        this.navigateToBookingInfo();
      } else {
        this.navigateToSelectService();
      }
    });
  }

  async navigateToSelectService() {
    try {
      const services = await this.fetchServices();
      this.clearAllSelectedServiceAndTimeSlots();

      const selectedInReservedOptions = _.map(this.state.bookings, booking => {
        return {
          booking,
          selected: 'NO_CHANGE',
        };
      });

      let nonReservedServices = _.cloneDeep(services);

      _.remove(nonReservedServices, service => {
        return !!_.find(this.state.bookings, booking => {
          return booking.service._id === service._id;
        });
      });

      this.setState({
        services,
        selectedInReservedOptions,
        nonReservedServices,
        step: 1,
      });
    } catch (err) {
      if (err) this.dialogs.error(MESSAGES.SYSTEM_BUSY[this.state.lang], this.state.lang);

      console.log('navigateToSelectService err:', err);
    }
  }

  isSelectedInTimeSlotValid() {
    let isValid = true;

    _.forEach(this.state.selectedInTimeSlot, item => {
      if (!_.size(item.timeSlotValue) || !item.noOfPeople > 0) isValid = false;
    })

    return isValid;
  }

  flashLastCalledTicket() {
    clearInterval(this.state.flashingTimer);

    let flashingTimer;
    let count = 0;
    flashingTimer = setInterval(() => {
      if (count > 9) {
        return clearInterval(flashingTimer);
      }

      count++;

      this.setState(prevState => {
        const isFlashing = !prevState.isFlashing;

        return { isFlashing };
      })
    }, 400);

    this.setState({
      flashingTimer,
    });
  }

  updateWidthFlag() {
    // this.setState({
    //   widthFlag: window.innerWidth < 576 ? 'xs' : '',
    // });
    this.setState({
      widthFlag: 'xs',
    });
  }

  selectReservedOption(booking, event, value) {
    let selectedInReservedOptions = _.cloneDeep(this.state.selectedInReservedOptions);

    selectedInReservedOptions = _.map(selectedInReservedOptions, (option) => {
      if (option.booking._id === booking._id) {
        _.set(option, 'selected', value);
      }

      return option;
    });

    const service = _.find(this.state.services, { _id: _.get(booking, 'service._id') });
    if (!service) return;

    if (value === 'CHANGE') {
      this.addTimeSlotsWithServices(service);
    } else {
      this.removeTimeSlotsWithServices(service);
    }

    this.setState({
      selectedInReservedOptions,
    });
  }

  selectNonReservedService(serviceSelected, event, isChecked) {
    let selectedInNonReservedServices = _.cloneDeep(this.state.selectedInNonReservedServices);

    const index = _.findIndex(selectedInNonReservedServices, {
      _id: serviceSelected._id,
    });

    if (index >= 0) {
      _.pullAt(selectedInNonReservedServices, [index]);
      this.removeTimeSlotsWithServices(serviceSelected);
    } else {
      selectedInNonReservedServices.push(serviceSelected);
      this.addTimeSlotsWithServices(serviceSelected);
    }

    this.setState({
      selectedInNonReservedServices,
    });
  }

  getTimeSlotValue(date, timeSlot) {
    return date + _.toString(timeSlot.startAtHour) + _.toString(timeSlot.startAtMinute);
  }

  addTimeSlotsWithServices(service, cb = constants.emptyFnc) {
    const self = this;

    const tryToAdd = function () {
      return new Promise(async (resolve, reject) => {
        try {
          DataAPI.get(`/api/public/timeSlots/${service._id}`, {}, (err, result) => {
            if (err) return reject(err);

            let timeSlotsWithServices = _.cloneDeep(self.state.timeSlotsWithServices);
            let selectedInTimeSlot = _.cloneDeep(self.state.selectedInTimeSlot);
            let timeSlotsToAdd = [];

            _.forEach(result, ({ date, timeSlots }) => {
              _.forEach(timeSlots, timeSlot => {
                _.assign(timeSlot, {
                  dateFormatted: date,
                  value: self.getTimeSlotValue(date, timeSlot),
                });

                timeSlotsToAdd.push(timeSlot);
              });
            });


            timeSlotsWithServices.push({
              service,
              timeSlots: timeSlotsToAdd,
            });
            selectedInTimeSlot.push({
              serviceId: service._id,
              timeSlotValue: '',
              noOfPeople: 0,
            });

            self.setState({
              timeSlotsWithServices,
              selectedInTimeSlot,
            }, resolve);
          });
        } catch (err) {
          reject(err);
        }
      })
    };

    pQueue.add(() => tryToAdd().then(() => {
      cb();
    }).catch((error) => {
      console.log('addTimeSlotsWithServices err:', error);
      this.dialogs.error(MESSAGES.SYSTEM_BUSY[this.state.lang], this.state.lang);
      cb(error);
    }));
  }

  removeTimeSlotsWithServices(serviceToRemove, cb = constants.emptyFnc) {
    const self = this;

    const tryToRemove = function () {
      return new Promise(async (resolve, reject) => {
        try {
          let timeSlotsWithServices = _.cloneDeep(self.state.timeSlotsWithServices);
          let selectedInTimeSlot = _.cloneDeep(self.state.selectedInTimeSlot);

          _.remove(timeSlotsWithServices, ({ service }) => {
            return service._id === serviceToRemove._id;
          });

          _.remove(selectedInTimeSlot, { serviceId: serviceToRemove._id });

          self.setState({
            timeSlotsWithServices,
            selectedInTimeSlot,
          }, resolve);
        } catch (err) {
          reject(err);
        }
      })
    };

    pQueue.add(() => tryToRemove().then(() => {
      cb();
    }).catch((error) => {
      console.log('removeTimeSlotsWithServices err:', error);
      cb(error);
    }));
  }

  clearAllSelectedServiceAndTimeSlots() {
    this.setState({
      timeSlotsWithServices: [],
      selectedInTimeSlot: [],
      selectedInNonReservedServices: [],
      selectedInReservedOptions: [],
      nonReservedServices: [],
    });
  }

  refreshLastCalledTicket(queue) {
    this.getLastCalledTicket(queue._id, (err, lastCalledTicket) => {
      if (err) return this.dialogs.error(MESSAGES.NETWORK_PROBLEM[this.state.lang], this.state.lang);

      let lastCalledTicketNumber;
      let ticket = _.cloneDeep(this.state.ticket);
      let shouldShowTicketPassed = false;

      if (lastCalledTicket) {
        lastCalledTicketNumber = lastCalledTicket.queue.code + _.padStart(lastCalledTicket.number, constants.numberOfTicketDigit, '0');
        shouldShowTicketPassed = lastCalledTicket.number > ticket.number;
      } else {
        lastCalledTicketNumber = queue.code + _.repeat('0', constants.numberOfTicketDigit);
      }

      if (ticket._id === _.get(lastCalledTicket, '_id')) {
        _.set(ticket, 'counter', lastCalledTicket.counter);
      }

      this.setState({
        lastCalledTicketNumber,
        ticket,
        shouldShowTicketPassed,
      });
    });
  }

  navigateToTimeSlots() {
    this.setState({
      isNavigateToTimeSlots: true,
    }, () => {
      async.until(
        (cb) => {
          cb(null, this.state.isQueueIdle);
        }, (next) => {
          setTimeout(() => {
            next();
          }, 200);
        }, () => {
          this.setState({
            isNavigateToTimeSlots: false,
          });

          if (_.size(this.state.timeSlotsWithServices)) {
            this.nextStep();
          } else {
            this.confirmTimeSlot();
          }
        });
    });
  }

  backInTimeSlotConfirmation() {
    if (_.size(this.state.timeSlotsWithServices)) {
      this.backStep();
    } else {
      this.setState({
        step: 1,
      });
    }
  }

  getTicket(ticketId, cb = constants.emptyFnc) {
    DataAPI.get(`/api/public/ticket/${ticketId}`, {}, cb);
  }

  getBookedTicketByUuid(bookedTicketUuid, cb = constants.emptyFnc) {
    DataAPI.get(`/api/public/bookedTicketByUuid/${bookedTicketUuid}`, {}, cb);
  }

  getBookedTicket(ticketId) {
    return new Promise((resolve, reject) => {
      DataAPI.get(`/api/public/bookedTicket/${ticketId}`, {}, (err, bookedTicket) => {
        if (err) return reject(err);

        resolve(bookedTicket);
      });
    });
  }

  nextStep() {
    // if (this.state.step === 3) {
    //   this.dialogs.alert({
    //     title: '如預約成功，將會發送短信給你。',
    //   });
    // }

    this.setState({
      step: this.state.step + 1,
    });
  }

  backStep() {
    this.setState({
      step: this.state.step - 1,
    });
  }

  backToFirstStep() {
    this.setState({
      step: 0,
    });
  }

  navigateToBooking() {
    this.setState({
      step: 1,
    });
  }

  fetchQueues() {
    DataAPI.get(`/api/public/queues`, {}, (err, queues) => {
      if (err) return this.dialogs.error(MESSAGES.NETWORK_PROBLEM[this.state.lang], this.state.lang);

      this.setState({
        queues,
      });
    });
  }

  updateInputState(field, value) {
    let input = _.cloneDeep(this.state.input);

    if (field === 'queueId') {
      const queueSelected = _.find(this.state.queues, { _id: value });
      const input = _.cloneDeep(EMPTY_INPUT);
      _.set(input, field, value);

      this.setState({
        queueSelected,
        input,
      });
    } else {
      _.set(input, field, value);

      this.setState({
        input,
      });
    }
  }

  confirmTimeSlot() {
    if (!this.isSelectedInTimeSlotValid()) return;

    this.setState({
      step: 3,
    });
  }

  createTicket(input) {
    this.setState({
      isProcessing: true,
    }, () => {
      DataAPI.put(`/api/public/${input.queueId}/createTicket`, _.omitBy({
        phoneNumber: input.phoneNumber,
        noOfStudent: input.noOfChild,
        email: input.email,
        orderNo: input.orderNo,
        smsLang: this.state.lang === 'en' ? 'en' : 'zh-tw',
      }, _.isNil), (err, ticket) => {
        this.setState({
          isProcessing: false,
        });

        if (err) return this.dialogs.error(MESSAGES.NETWORK_PROBLEM[this.state.lang], this.state.lang);

        const ticketId = ticket._id;
        const expires = moment().endOf('day').toDate();
        cookies.set('ticketId', ticketId, { expires, path: '/' });

        this.setState({
          ticketId,
          ticket,
        }, () => {
          this.refreshLastCalledTicket(ticket.queue);
        });
      });
    });
  }

  isSubmitButtonDisabled() {
    const isDisabled = this.state.isProcessing
      || !!!_.size(this.state.input.queueId)
      || (_.get(this.state.queueSelected, 'online.shouldInputNoOfStudent') && !!!_.size(_.toString(this.state.input.noOfChild)))
      || (_.get(this.state.queueSelected, 'online.shouldInputPhoneNo') && !!!_.size(this.state.input.phoneNumber))
      || (_.get(this.state.queueSelected, 'online.shouldInputEmail') && !!!_.size(this.state.input.email))
      || (_.get(this.state.queueSelected, 'online.shouldInputOrderNo') && !!!_.size(this.state.input.orderNo));

    return isDisabled;
  }

  formatBookedTicketNumber(bookedTicket) {
    return bookedTicket.queueCode + _.padStart(bookedTicket.ticketNumber, constants.numberOfTicketDigit, '0');
  }

  formatTicketNumber(ticket) {
    return ticket.queue.code + _.padStart(ticket.number, constants.numberOfTicketDigit, '0');
  }

  getLastCalledTicket(queueId, cb = constants.emptyFnc) {
    DataAPI.get(`/api/public/lastCalledTicket/${queueId}`, {}, cb);
  }

  formatTicketCreatedAt(ticket) {
    const format = this.state.lang === 'en' ? 'DD/MM/YYYY' : 'YYYY年MM月DD日';

    return moment(ticket.createdAt).format(format);
  }

  formatTimeSlotTime(timeSlot, showFullText) {
    const format = this.state.lang === 'en' ? 'DD/MM' : 'MM月DD日';

    let output = moment(timeSlot.dateFormatted, DATE_FORMAT).format(format)
      + ' '
      + _.padStart(_.toString(timeSlot.startAtHour), 2, '0')
      + ':'
      + _.padStart(_.toString(timeSlot.startAtMinute), 2, '0')
      + ' - '
      + _.padStart(_.toString(timeSlot.endAtHour), 2, '0')
      + ':'
      + _.padStart(_.toString(timeSlot.endAtMinute), 2, '0');

    if (showFullText && !timeSlot.hvQuota) output += ' ' + (this.state.lang === 'en' ? 'Full' : '已滿');

    return output;
  }

  getTimeSlotBySelected(selected) {
    const timeSlotsWithServiceFound = _.find(this.state.timeSlotsWithServices, ({ service }) => {
      return service._id === selected.serviceId;
    });

    const timeSlot = _.find(timeSlotsWithServiceFound.timeSlots, { value: selected.timeSlotValue });

    return timeSlot;
  }

  formatSelectTimeSlotTime(selected) {
    const timeSlot = this.getTimeSlotBySelected(selected);

    return this.formatTimeSlotTime(timeSlot, false);
  }

  getSelectedInTimeSlot(serviceId) {
    return _.find(this.state.selectedInTimeSlot, (item) => {
      return item.serviceId === serviceId;
    });
  }

  updateSelectedInTimeSlot(serviceId, field, value) {
    let selectedInTimeSlot = _.cloneDeep(this.state.selectedInTimeSlot);

    selectedInTimeSlot = _.map(selectedInTimeSlot, (item) => {
      if (item.serviceId === serviceId) {
        _.set(item, field, value);
      }

      return item;
    });

    this.setState({
      selectedInTimeSlot,
    });
  }

  updateBookedTicket(roomNo) {
    return new Promise((resolve, reject) => {
      DataAPI.post(`/api/public/bookedTicket/${this.state.bookedTicket._id}`, {
        roomNo,
      }, (err) => {
        if (err) {
          // this.dialogs.error(MESSAGES.SYSTEM_BUSY[this.state.lang], this.state.lang);
          return reject(err);
        }

        this.setState(prevState => {
          const bookedTicket = _.assign(_.cloneDeep(prevState.bookedTicket), {
            roomNo,
          });

          return { bookedTicket };
        }, resolve)

        // this.getBookedTicketByUuid(this.state.bookedTicketUuid, (err, bookedTicket) => {
        //   if (err) {
        //     // this.dialogs.error(MESSAGES.SYSTEM_BUSY[this.state.lang], this.state.lang);
        //     return reject(err);
        //   }
        //
        //   this.setState({
        //     bookedTicket,
        //   }, resolve);
        // });
      });
    });
  }

  async confirmBooking() {
    let roomNo = this.state.bookedTicket.roomNo;

    if (!_.size(roomNo) && _.size(_.trim(this.state.input.roomNo))) {
      roomNo = this.state.input.roomNo;
      await this.updateBookedTicket(roomNo).catch((err) => {
        this.dialogs.error(MESSAGES.SYSTEM_BUSY[this.state.lang], this.state.lang);
      });
    }

    const timeSlotWithDate = _.map(this.state.selectedInTimeSlot, selected => {
      let timeSlot = this.getTimeSlotBySelected(selected);

      _.assign(timeSlot, {
        serviceId: selected.serviceId,
        noOfPeople: selected.noOfPeople,
        category: _.get(_.find(this.state.services, { _id: selected.serviceId }), 'bookingSelection.category'),
      });

      return timeSlot;
    });

    let options = _.map(this.state.selectedInReservedOptions, option => {
      return {
        serviceId: _.get(option, 'booking.service._id'),
        action: option.selected, // RESERVED_OPTIONS
      };
    });

    _.forEach(this.state.selectedInNonReservedServices, service => {
      options.push({
        serviceId: service._id,
        action: 'CREATE',
      });
    });

    DataAPI.put(`/api/public/booking/${this.state.bookedTicket._id}`, {
      timeSlotWithDate,
      options,
      // phoneNumber: this.state.bookedTicket.phoneNumber,
      lang: this.state.lang,
    }, (err, result) => {
      if (err) return this.dialogs.error(err);

      let errorsInBookingInfo = [];
      _.forEach(result, item => {
        if (item.error) {
          errorsInBookingInfo.push({
            service: _.find(this.state.services, { _id: item.serviceId }),
            errorMsg: _.get(_.head(item.error.errors), 'message'),
          });
        }
      });

      this.setState({
        errorsInBookingInfo,
      }, this.navigateToBookingInfo);
    });
  }

  confirmRoomNo() {
    if (!_.size(_.trim(this.state.input.roomNo))) {
      return this.dialogs.error(MESSAGES.PLEASE_INPUT_ROOM_NO[this.state.lang], this.state.lang);
    }

    this.updateBookedTicket(this.state.input.roomNo).then(() => {
      DataAPI.post(`/api/public/sendSms/${this.state.bookedTicket._id}`, {});

      this.nextStep();
    }).catch((err) => {
      this.dialogs.error(MESSAGES.SYSTEM_BUSY[this.state.lang], this.state.lang);
    });
  }

  fetchBookings(cb = constants.emptyFnc) {
    DataAPI.get(`/api/public/bookings/${this.state.bookedTicket._id}`, {}, (err, bookings) => {
      if (err) return this.dialogs.error(MESSAGES.SYSTEM_BUSY[this.state.lang], this.state.lang);

      bookings = _.map(bookings, booking => {
        return _.set(booking, 'dateFormatted', moment(booking.date).format(DATE_FORMAT));
      });
      this.setState({
        bookings,
      }, cb);
    });
  }

  navigateToInputRoomNo() {
    this.setState({
      isRoomNoInputState: true,
    }, this.backStep);
  }

  backFromRoomNoInputState() {
    this.setState({
      isRoomNoInputState: false,
    }, this.nextStep);
  }

  cancelTicket() {
    this.dialogs.confirm({
      title: MESSAGES.CONFIRM_CANCEL_TICKET[this.state.lang],
      lang: this.state.lang,
    }, () => {
      DataAPI.post(`/api/public/cancelTicket/${this.state.ticketId}`, {}, (err, ticket) => {
        if (err) return this.dialogs.error(MESSAGES.NETWORK_PROBLEM[this.state.lang], this.state.lang);

        cookies.remove('ticketId');
        window.location.reload();
      });
    });
  }

  render() {
    const wrapOnChange = (fnc, field, event, value) => {
      fnc(field, value);
    };

    const wrapSelectFieldOnChange = (fnc, field, event, index, value) => {
      fnc(field, value);
    };

    const wrapOnChangeInTimeSlot = (fnc, serviceId, field, event, value) => {
      fnc(serviceId, field, value);
    };

    const wrapSelectFieldOnChangeInTimeSlot = (fnc, serviceId, field, event, index, value) => {
      fnc(serviceId, field, value);
    };

    return (
      <div>
        <div className={`${_.toLower(this.state.lang)} ${this.state.widthFlag} ticket-block`}>
          {/*<div className="header-row-1-block">*/}
          {/*<div className="main-block">*/}
          {/*<div className="right-block">*/}
          {/*  <LanguageIcon className="icon" />*/}
          {/*  <a className={(this.state.lang === 'en' ? 'active' : '') + ' en'}*/}
          {/*     href={window.location.origin + window.location.pathname + (_.size(this.state.bookedTicketUuid) ? '?ticket=' + this.state.bookedTicketUuid : '')}*/}
          {/*     target="_self">EN</a>*/}
          {/*  <a className={(this.state.lang === 'zhTW' ? 'active' : '') + ' zhtw'}*/}
          {/*     href={window.location.origin + window.location.pathname + '?lang=zhTW' + (_.size(this.state.bookedTicketUuid) ? '&ticket=' + this.state.bookedTicketUuid : '')}*/}
          {/*     target="_self">繁</a>*/}
          {/*</div>*/}
          {/*</div>*/}
          {/*</div>*/}
          <div className="header-row-2-block">
            <div className="header-row-2-main">
              <div className="header-row2-col1">
                <div className="logo-wrapper">
                  <a href="https://www.schooluniform.hk/" title="Schooluniform">
                    <img src="/images/logo-white.png"
                         alt="Logo" />
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="form-block">
            <div className={`main-block`}>
              {
                this.state.ticket ?
                  <div>
                    {
                      this.state.step === 0 && this.state.ticket &&
                      <div className="queue-waiting-block">
                        {
                          this.state.shouldShowTicketPassed &&
                          <div className="ticket-passed-text">
                            This Ticket Has Been Passed
                          </div>
                        }
                        {
                          _.get(this.state.ticket, 'counter') ?
                            <div>
                              <div className="your-number">
                                <div className="title">
                                  {MESSAGES.YOUR_NUMBER[this.state.lang]}
                                </div>
                                <div className="number">
                                  {this.formatTicketNumber(this.state.ticket)}
                                </div>
                              </div>

                              <div className="counter-text">
                                {MESSAGES.PLEASE_APPROACH_G_FLOOR[this.state.lang]}
                              </div>
                              {/*<div*/}
                              {/*className="counter-name blink_me">{this.state.ticket.counter.name}</div>*/}
                            </div>
                            :
                            <div>
                              <div className="last-called-number">
                                <div className="title">
                                  {MESSAGES.LAST_CALLED_NUMBER[this.state.lang]}
                                </div>
                                <div
                                  className={(this.state.isFlashing ? 'flashing ' : '') + 'number'}>
                                  {this.state.lastCalledTicketNumber}
                                </div>
                              </div>

                              <div className="your-number">
                                <div className="title">
                                  {MESSAGES.YOUR_NUMBER[this.state.lang]}
                                </div>
                                <div className="number">
                                  {this.formatTicketNumber(this.state.ticket)}
                                </div>
                              </div>

                              <div className="remark">
                                {MESSAGES.TICKET_REMARK_MSG[this.state.lang]}
                              </div>
                            </div>
                        }
                        {/*<div className="booking-button-block">*/}
                        {/*  <RaisedButton*/}
                        {/*    label={MESSAGES.MAKE_RESERVATION[this.state.lang]}*/}
                        {/*    primary={true}*/}
                        {/*    icon={<EventIcon />}*/}
                        {/*    onClick={this.navigateToReservation} />*/}
                        {/*</div>*/}
                        <div onClick={this.cancelTicket} className="cancel-block">
                          {MESSAGES.CANCEL_TICKET[this.state.lang]}
                        </div>
                      </div>
                    }
                  </div>
                  :
                  <div>
                    <div className="last-called-number-block">
                      <div className="current-name-text">Current Number</div>
                      <div className="all-number-block">
                        {
                          _.map(this.state.lastCalledTickets, (ticket, index) => (
                            <div key={index} className="number-block">
                              {ticket.code + ticket.numberToShow}
                            </div>
                          ))
                        }
                      </div>

                    </div>
                    <div className="input-row-block">
                      <div className="label-block">{MESSAGES.SERVICE[this.state.lang]}</div>
                      <div className="input-block">
                        <SelectField
                          hintText={MESSAGES.SELECT_SERVICE[this.state.lang]}
                          value={this.state.input.queueId}
                          onChange={wrapSelectFieldOnChange.bind(this, this.updateInputState, 'queueId')}
                          style={{
                            // width: 200,
                          }}
                        >
                          {
                            _.map(this.state.queues, (queue, index) => (
                              <MenuItem key={index} value={queue._id}
                                        primaryText={queue.code + '. ' + _.get(queue.onlineName, this.state.lang)} />
                            ))
                          }
                        </SelectField>
                      </div>
                      <div className="info-block">
                        {
                          _.map(_.get(this.state.queueSelected, 'onlineInfo'), (info, index) => (
                            <div key={index} dangerouslySetInnerHTML={{ __html: info }} />
                          ))
                        }
                      </div>
                    </div>

                    {
                      _.get(this.state.queueSelected, 'online.shouldInputNoOfStudent') &&
                      <div className="input-row-block">
                        <div className="label-block">{MESSAGES.NO_OF_STUDENT[this.state.lang]}</div>
                        <div className="input-block">
                          <SelectField
                            hintText={MESSAGES.SELECT_NO_OF_STUDENT[this.state.lang]}
                            value={this.state.input.noOfChild}
                            onChange={wrapSelectFieldOnChange.bind(this, this.updateInputState, 'noOfChild')}
                            style={{
                              // width: 200,
                            }}
                          >
                            {
                              _.map(_.range(4), (number, index) => (
                                <MenuItem key={index} value={number + 1}
                                          primaryText={number + 1} />
                              ))
                            }
                          </SelectField>
                        </div>
                      </div>
                    }

                    {
                      _.get(this.state.queueSelected, 'online.shouldInputPhoneNo') &&
                      <div className="input-row-block">
                        <div className="label-block">
                          <div className="first-row">{MESSAGES.PHONE_NUMBER[this.state.lang]}</div>
                        </div>
                        <div className="input-block">
                          <TextField
                            hintText={MESSAGES.YOUR_PHONE_NUMBER[this.state.lang]}
                            value={this.state.input.phoneNumber}
                            type="number"
                            onChange={wrapOnChange.bind(this, this.updateInputState, 'phoneNumber')}
                            style={{
                              // width: 200,
                            }}
                          /><br />
                        </div>
                      </div>
                    }

                    {
                      _.get(this.state.queueSelected, 'online.shouldInputEmail') &&
                      <div className="input-row-block">
                        <div className="label-block">
                          <div className="first-row">{MESSAGES.EMAIL[this.state.lang]}</div>
                        </div>
                        <div className="input-block">
                          <TextField
                            hintText={MESSAGES.YOUR_EMAIL[this.state.lang]}
                            value={this.state.input.email}
                            onChange={wrapOnChange.bind(this, this.updateInputState, 'email')}
                            style={{
                              // width: 200,
                            }}
                          /><br />
                        </div>
                      </div>
                    }

                    {
                      _.get(this.state.queueSelected, 'online.shouldInputOrderNo') &&
                      <div className="input-row-block">
                        <div className="label-block">
                          <div className="first-row">{MESSAGES.ORDER_NO[this.state.lang]}</div>
                        </div>
                        <div className="input-block">
                          <TextField
                            hintText={MESSAGES.YOUR_ORDER_NO[this.state.lang]}
                            value={this.state.input.orderNo}
                            onChange={wrapOnChange.bind(this, this.updateInputState, 'orderNo')}
                            style={{
                              // width: 200,
                            }}
                          /><br />
                        </div>
                      </div>
                    }

                    <div className="submit-block">
                      <RaisedButton
                        label={
                          this.state.isProcessing ?
                            <CircularProgress size={30} style={{
                              marginTop: 3,
                            }} />
                            :
                            MESSAGES.SUBMIT[this.state.lang]
                        }
                        primary={true}
                        onClick={this.createTicket.bind(this, this.state.input)}
                        disabled={this.isSubmitButtonDisabled()} />
                    </div>
                    {
                      this.state.isProcessing &&
                      <div className="message-block">{MESSAGES.SUBMITTING[this.state.lang]}</div>
                    }
                  </div>
              }
            </div>
          </div>
          <div className="footer-block">
            <div className="inner-block">
              <p
                className="text"> {(this.state.lang === 'en' ? `Powered by © ${moment().format('YYYY')} Lemon Dice Studio ` : ` 由 © ${moment().format('YYYY')} 檸檬骰有限公司系統支援`)}</p>
            </div>
          </div>
        </div>
        <Dialogs onInit={dialog => (this.dialogs = dialog)} />
      </div>
    )
  }

}

export default Ticket;


// WEBPACK FOOTER //
// client/ticket/Ticket.js